import type { ApiClient } from "../auth/apiClient";
import { NextWorkItemResponseSchema } from "./types";
import type { NextWorkItemResponse } from "./types";

/**
 * Press "Next": ask the dispenser for the single most important due item
 * across every queue the caller belongs to, locking it server-side before
 * it returns. The caller's identity travels in the bearer token, so this
 * takes no parameters.
 *
 * Despite being a `GET`, this is *not* idempotent — the server takes a
 * lock as a side effect of the read — which is why it is driven from a
 * mutation hook (fired on a click) rather than a `useQuery` (fired on
 * mount). The endpoint always answers `200`: a populated `item`, a
 * `reServed` item, or `item: null` for "nothing to do". A non-OK status
 * is therefore a genuine transport/auth failure and surfaces as an error.
 */
export async function fetchNextWorkItem(
    client: ApiClient,
): Promise<NextWorkItemResponse> {
    const response = await client.fetch("/workitems/next");

    if (!response.ok) {
        throw new Error(
            `Failed to get next work item: ${String(response.status)} ${response.statusText}`,
        );
    }

    const json: unknown = await response.json();
    return NextWorkItemResponseSchema.parse(json);
}
